import { render, staticRenderFns } from "./submit-btn.vue?vue&type=template&id=51a57e86&"
import script from "./submit-btn.vue?vue&type=script&lang=js&"
export * from "./submit-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports